/*
 * @name: getters
 * @Author: zxc
 * @Date: 2020-09-04 15:12:17
 * @LastEditors: zxc
 * @LastEditTime: 2021-09-01 16:48:32
 */
const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  lang: state => state.app.lang,
  device: state => state.app.device,
  permission_routes: state => state.permission.routes,
  // 路由
  beforeNewRoute: state => state.router.beforeNewRoute,
  beforeRoute: state => state.router.beforeRoute,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js